import localforage from "localforage";
import React, { useContext, useMemo, useState } from "react";

export const GlobalProviderContext = React.createContext({});
export const GlobalActionContext = React.createContext({});

let currentCompanyId;
let currentCompanyName;
let menuFixedOpen = false;
export const useGlobalState = () => {
  return useContext(GlobalProviderContext);
};

export const useGlobalDispatch = () => {
  return useContext(GlobalActionContext);
};

export const getCurrentCompanyId = async () => {
  return currentCompanyId || (await localforage.getItem("currentCompanyId"));
};


export const getCurrentCompanyName = async () => {
  return (
    currentCompanyName || (await localforage.getItem("currentCompanyName"))
  );
};

export default ({ children }) => {
  const [state, setCurrentState] = useState({});

  const action = useMemo(() => {
    return {
      setCurrentCompany: async (id, name) => {
        await localforage.setItem("currentCompanyId", id);
        await localforage.setItem("currentCompanyName", name);
        currentCompanyId = id;
        currentCompanyName = name;
        setCurrentState(preState => ({
          ...preState,
          ...{
            currentCompanyId: id,
            currentCompanyName: name
          }
        }));
      },

      setLeftMenuStatus: async (status) => {
        setCurrentState(preState => ({
          ...preState,
          menuFixedOpen: status
        }));
      }
    };
  }, []);

  return (
    <GlobalProviderContext.Provider value={state}>
      <GlobalActionContext.Provider value={action}>
        {children}
      </GlobalActionContext.Provider>
    </GlobalProviderContext.Provider>
  );
};
